import script from "./PaymentErrorPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaymentErrorPopup.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__